import { IButtonsValueDisp } from "../../interfaces/IButtonsValueDisp";

import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;

export class BasicButtonValueContainer implements IButtonsValueDisp {
    private more: Container;
    private less: Container;
    private max: Container;

    constructor(buttonContainer: Container) {
        this.more = (<Container>buttonContainer.getChildByName("btn_more"));
        this.less = (<Container>buttonContainer.getChildByName("btn_less"));
        this.max = (<Container>buttonContainer.getChildByName("btn_max"));
    }

    public getMoreButton(): DisplayObject {
        return this.more;
    }

    public getLessButton(): DisplayObject {
        return this.less;
    }

    public getMaxButton(): DisplayObject {
        return this.max;
    }
}
